import { createFileRoute, useRouter } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const Route = createFileRoute("/confirm")({
  component: ConfirmPage,
  head: () =>
    buildSeo({
      title: "Confirmando cuenta · Bizaclia",
      description: "Confirma tu cuenta de Bizaclia.",
      path: "/confirm",
      noindex: true,
    }),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-md py-16 text-center">
      <h1 className="text-2xl font-semibold mb-2">Error</h1>
      <p className="text-muted-foreground">{error.message}</p>
    </div>
  ),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-md py-16 text-center">
      <h1 className="text-2xl font-semibold">No encontrado</h1>
    </div>
  ),
});

function ConfirmPage() {
  const router = useRouter();
  const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");
  const [message, setMessage] = useState("Confirmando tu cuenta…");

  useEffect(() => {
    const url = new URL(window.location.href);
    const tokenHash = url.searchParams.get("token_hash");
    const type = (url.searchParams.get("type") || "signup") as
      | "signup"
      | "email";
    if (!tokenHash) {
      setStatus("error");
      setMessage("El enlace no es válido.");
      return;
    }
    supabase.auth.verifyOtp({ token_hash: tokenHash, type }).then(({ error }) => {
      if (error) {
        setStatus("error");
        setMessage("El enlace ha caducado o ya fue usado.");
        return;
      }
      setStatus("ok");
      setMessage("¡Cuenta confirmada! Ya puedes empezar a usar Bizaclia.");
      toast.success("Cuenta confirmada");
      window.history.replaceState({}, "", "/confirm");
    });
  }, []);

  return (
    <div className="container mx-auto max-w-md py-16 px-4 text-center">
      <h1 className="text-2xl font-semibold mb-3">
        {status === "ok" ? "Cuenta confirmada" : "Confirmación"}
      </h1>
      <p className="text-muted-foreground mb-6">{message}</p>
      {status === "ok" && (
        <Button onClick={() => router.navigate({ to: "/" })}>
          Ir al inicio
        </Button>
      )}
    </div>
  );
}
